import useDefinedContext from "hooks/useDefinedContext";
import WellnessMetadataStatusContext from "../contexts/WellnessMetadataStatusContext";

interface UseWellnessProps {}

function useWellnessMetadataStatus(props?: UseWellnessProps) {
  return useDefinedContext(WellnessMetadataStatusContext);
}

export default useWellnessMetadataStatus;
